import React from "react";
import { observer } from "mobx-react-lite";
import { useRootStore } from "../../../../store/contexts";
import { ErrorDialog } from "../../../../common/controls";
import { WorkAuthorListStore } from "../../store/WorkAuthorListStore";

type WorkAuthorListDialogsProps = {
  store: WorkAuthorListStore;
};

/**
 * Componente que agrupa todos los dialogs del listado de WorkAuthor.
 * Separado para mantener WorkAuthorListPage más limpio.
 */
export const WorkAuthorListDialogs: React.FC<WorkAuthorListDialogsProps> =
  observer(({ store }) => {
    const { langStore } = useRootStore();

    return (
      <>
        {/* Dialog de error genérico */}
        <ErrorDialog
          open={store.errorDialogOpened}
          title={store.errorTitle || langStore.errorTitle}
          description={store.errorDescription}
          onClose={() => store.closeErrorDialog()}
        />
      </>
    );
  });
